// Bounding-box normalisation. Admin-0 (`country_bounds`) and admin-1
// (`admin_one_bounds`) are stored with different key conventions across the
// dataset; the reporting `Map` component wants `{minx, miny, maxx, maxy}`.

/**
 * Coerce any of the bounds shapes we see (`{minx..}`, `{xmin..}`, `[x,y,x,y]`)
 * into the `{minx, miny, maxx, maxy}` object the map expects.
 *
 * @param {object|Array|null|undefined} bounds
 * @returns {{minx: number, miny: number, maxx: number, maxy: number}|null}
 */
export function normalizeBounds(bounds) {
  if (!bounds) return null;

  if (Array.isArray(bounds) && bounds.length === 4) {
    const [minx, miny, maxx, maxy] = bounds.map(Number);
    return { minx, miny, maxx, maxy };
  }

  const minx = bounds.minx ?? bounds.xmin ?? bounds.west;
  const miny = bounds.miny ?? bounds.ymin ?? bounds.south;
  const maxx = bounds.maxx ?? bounds.xmax ?? bounds.east;
  const maxy = bounds.maxy ?? bounds.ymax ?? bounds.north;

  if ([minx, miny, maxx, maxy].some((v) => v == null || Number.isNaN(Number(v)))) {
    return null;
  }
  return { minx: Number(minx), miny: Number(miny), maxx: Number(maxx), maxy: Number(maxy) };
}
